<template>
</template>

<script>
export default {
	name: 'ProductList',
	props: {
		items: Array,
		currency: String
	},
	mounted() {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({'event_params': null, 'ecommerce': null});
		window.dataLayer.push({
			'event': 'RO_event_EEC',
			'event_params': {
				'gtm_name': 'EEC_view_item_list',
			},
			'ecommerce': {
				'currency': global.current_currency,
				'items': Object.values(this.items).map(item => {
					Object.keys(item).forEach(attribute => {
						if (item[attribute] === 'undefined') {
							item[attribute] = undefined
						}
						if (item[attribute] === '') {
							item[attribute] = undefined
						}
					})
					return item
				})
			}
		})
	}
}
</script>
